<template>
  <v-container grid-list-xs fluid>
    <v-layout row wrap class="white shadow px-3 pb-3" justify-center>
      <v-flex xs12 class="di-flex align-center mb-3">
        <v-autocomplete
          chips
          multiple
          clearable
          single-line
          hide-details
          return-object
          item-text="text"
          :items="filters"
          item-value="text"
          :label="$t('filtery_by')"
          v-model="selected_filters"
          prepend-inner-icon="mdi-filter-variant"
        >
          <template v-slot:selection="data">
            <v-chip
              close
              :selected="data.selected"
              class="chip--select-multi"
              @input="removeFilter(data.item)"
              >{{ data.item.text }}</v-chip
            >
          </template>
        </v-autocomplete>
      </v-flex>

      <div class="flex xs12 border pa-3 white">
        <h3>Filter Values</h3>
        <v-divider class="my-2"></v-divider>
        <component
          :key="index"
          @print="printTable"
          v-bind="filter.props"
          v-model="filter.value"
          v-bind:is="filter.component"
          v-for="(filter, index) in selected_filters"
        />
        <div class="di-flex justify-end mt-3">
          <v-btn color="primary" class="shadow" @click="getData"
            >Generate Report</v-btn
          >
        </div>
      </div>
    </v-layout>

    <!-- DATA TABLE -->
    <v-card class="layout row wrap shadow pa-3 mt-3">
      <div class="flex-row justify-space-between align-center grey lighten-4">
        <strong class="title_label pl-2" slot="activator">
          <span>{{ `${items.length} Results` }}</span>
        </strong>
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              flat
              v-on="on"
              color="grey darken-2"
              class="ma-0 mr-2 pa-0"
              @click="printTable(false)"
            >
              <v-icon>print</v-icon>
            </v-btn>
          </template>
          <span>Print Table</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              flat
              v-on="on"
              color="grey darken-2"
              class="ma-0 mr-2 pa-0"
              @click="printTable(true)"
            >
              <v-icon>file_download</v-icon>
            </v-btn>
          </template>
          <span>Excel Export</span>
        </v-tooltip>
      </div>

      <v-data-table
        ref="tbl"
        :items="items"
        class="flex xs12"
        :headers="headers"
        :loading="loading"
        disable-initial-sort
        :rows-per-page-items="per_page"
      >
        <template v-slot:items="props">
          <tr @click="props.expanded = !props.expanded">
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.name }}</td>
            <td>{{ props.item.assessment_date }}</td>
            <td>
              {{ props.item.operational_areas.map(x => x.name).join(", ") }}
            </td>
            <td>{{ props.item.program_areas.map(x => x.name).join(", ") }}</td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.phone }}</td>
            <td>{{ props.item.website }}</td>
            <td>{{ props.item.president }}</td>
            <td>{{ props.item.assessment_funded_by }}</td>
            <td :class="props.item.latest_assessment.decision">
              {{ props.item.latest_assessment.decision }}
            </td>

            <td>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    flat
                    small
                    v-on="on"
                    class="ma-0 pa-0"
                    color="grey darken-2"
                    v-if="can('view_CSOs')"
                    :to="`/CSOs/${props.item.id}`"
                  >
                    <v-icon>mdi-launch</v-icon>
                  </v-btn>
                </template>
                <span>View</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
        <template v-slot:expand="{ item }">
          <v-card flat class="pa-2">
            <score-card-summary :summary="item.latest_assessment.summary" />
          </v-card>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
let currentDate = new Date();
currentDate.setDate(currentDate.getDate() - 7);

export default {
  name: "reports-view",
  data: () => ({
    items: [],
    loading: false,
    programAreas: [],
    selected_filters: [],
    end_date: new Date().toISOString().substring(0, 10),
    start_date: currentDate.toISOString().substring(0, 10)
  }),
  computed: {
    filters: vm => [
      {
        value: null,
        field: "name",
        text: vm.$t("name"),
        component: "v-text-field",
        props: {
          label: vm.$t("name")
        }
      },
      {
        value: null,
        field: "status",
        text: vm.$t("status"),
        component: "vAutocomplete",
        props: {
          label: vm.$t("status"),
          items: ["Pending", "Certified", "Deferred"]
        }
      },

      {
        value: null,
        field: "program_areas",
        component: "vAutocomplete",
        text: vm.$t("program_areas"),
        props: {
          multiple: true,
          itemValue: "id",
          itemText: "name",
          label: vm.$t("program_areas"),
          items: vm.programAreas.filter(x => x.type == "program")
        }
      },
      {
        value: null,
        field: "operational_areas",
        component: "vAutocomplete",
        text: vm.$t("operational_areas"),
        props: {
          multiple: true,
          itemValue: "id",
          itemText: "name",
          label: vm.$t("operational_areas"),
          items: vm.programAreas.filter(x => x.type == "province")
        }
      },
      {
        value: new Date().toISOString().substring(0, 10),
        text: "Assessements From",
        component: "date",
        field: "start_date",
        props: {
          label: "Assessements From"
        }
      },
      {
        value: new Date().toISOString().substring(0, 10),
        text: "Assessements Until",
        component: "date",
        field: "end_date",
        props: {
          label: "Assessements Until"
        }
      },
      {
        value: new Date().toISOString().substring(0, 10),
        text: "Expires-ON",
        component: "date",
        field: "expire_date",
        props: {
          label: "Expires-ON"
        }
      },
      {
        value: new Date().toISOString().substring(0, 10),
        text: "Needs Re-Assessment",
        component: "date",
        field: "reminder_date",
        props: {
          label: "Needs Re-Assessment"
        }
      },
      {
        value: null,
        field: "assessment_funded_by",
        text: vm.$t("assessment_funded_by"),
        component: "v-text-field",
        props: {
          label: vm.$t("assessment_funded_by")
        }
      }
    ],

    headers: vm => [
      { text: vm.$t("id"), sortable: false, width: "100px" },
      { text: "CSOs Name", value: "name" },

      { text: vm.$t("assessment_date"), value: "assessment_date" },
      {
        value: "operational_areas",
        text: vm.$t("operational_areas"),
        computed: item => item.operational_areas.map(x => x.name).join(", ")
      },
      {
        value: "program_areas",
        text: vm.$t("program_areas"),
        computed: item => item.program_areas.map(x => x.name).join(", ")
      },
      { text: vm.$t("email"), value: "email" },
      { text: vm.$t("phone"), value: "phone" },
      { text: vm.$t("website"), value: "website" },
      { text: vm.$t("president"), value: "president" },
      { text: vm.$t("assessment_funded_by"), value: "assessment_funded_by" },
      { text: vm.$t("status"), value: "latest_assessment.decision" },
      { text: vm.$t("actions"), sortable: false, width: "200px" }
    ]
  },

  methods: {
    removeFilter(item) {
      const index = this.selected_filters.indexOf(item);
      if (index >= 0) this.selected_filters.splice(index, 1);
    },

    getData() {
      this.loading = true;
      let filter = this.selected_filters
        .map(item => `${item.field}=${item.value}`)
        .join("&&");

      this.axios
        .get(`CSOs?${filter}`)
        .then(res => {
          this.items = res.data.data;
          this.loading = false;
        })
        .catch(vm => (vm.loading = false));
    },

    printTable(excel) {
      let headers = this.headers.slice(1, this.headers.length - 1);
      if (excel)
        headers.push(
          { text: this.$t("registration_date"), value: "registration_date" },
          {
            value: "program_areas",
            text: this.$t("program_areas"),
            computed: cso => cso.program_areas.map(x => x.name).join(", ")
          },
          {
            value: "operational_areas",
            text: this.$t("operational_areas"),
            computed: cso => cso.operational_areas.map(x => x.name).join(", ")
          },
          { text: this.$t("registered_office"), value: "registered_office" },
          { text: this.$t("board_of_directors"), value: "board_of_directors" },
          { text: this.$t("staff_size"), value: "staff_size" },
          { text: this.$t("paid_fee"), value: "paid_fee" }
        );
      let data = {
        headers,
        title: `Lists of CSOs`,
        items: this.$refs.tbl.filteredItems
      };

      if (excel) return this.xl_tables(data, "CSOs");
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    }
  },
  created() {
    this.axios.get("program-areas").then(res => {
      this.programAreas = res.data.data;
    });
  }
};
</script>
